import { useField } from 'formik';
import { motion } from 'framer-motion';

interface ILegalInputField {
  type: 'text' | 'email' | 'number' | 'password';
  placeholder: string;
  label: string;
  name: string;
  isDisabled?: boolean;
  isRequired?: boolean;
}

const LegalInputField = ({
  type,
  name,
  label,
  placeholder,
  isDisabled,
  isRequired,
}: ILegalInputField) => {
  // integration of formik hooks here
  const [field, meta] = useField(name);

  // rendering custom input field component here
  return (
    <div>
      <label
        htmlFor={`input-${name}`}
        title={isRequired ? 'This field is required' : ''}
        className='block mb-1 text-legal-brown font-semibold text-base'
      >
        {label} {isRequired && <span className='text-base-red'>*</span>}
      </label>

      <motion.div
        initial={{ x: 0 }}
        animate={
          meta.touched && meta.error
            ? {
                x: [0, -10, 0, 10, 0],
                transition: {
                  duration: 0.1,
                  repeat: 2,
                },
              }
            : { x: 0 }
        }
        className='relative'
      >
        <div className='flex flex-col md:flex-row items-end gap-3'>
          <input
            id={`input-${name}`}
            type={type}
            className={`border-2 focus:ring-4 focus:ring-legal-brown outline-legal-brown bg-transparent w-full p-3 text-legal-brown font-semibold duration-300 text-base disabled:opacity-40 disabled:cursor-not-allowed read-only:opacity-60 read-only:focus:ring-0 ${
              meta.touched && meta.error
                ? 'border-base-red'
                : 'border-legal-brown'
            }`}
            placeholder={placeholder}
            disabled={isDisabled}
            autoComplete='off'
            {...field}
          />
        </div>
      </motion.div>

      <motion.label
        initial={{ y: -20, opacity: 0, display: 'none' }}
        animate={
          meta.touched && meta.error
            ? { y: 0, opacity: 1, display: 'block' }
            : { y: -20, opacity: 0, transitionEnd: { display: 'none' } }
        }
        htmlFor={`input-${name}`}
        className='block mt-1 text-base-red text-base'
      >
        {meta.error}
      </motion.label>
    </div>
  );
};

export default LegalInputField;
